import styled from 'styled-components';

import { OnboardingPage } from '../../../../components/Page';

export const ReplikaChatVibeStyles = styled(OnboardingPage)`
  padding: 20px 0 0;

  ion-content {
    &::part(scroll) {
      display: grid;
      place-items: center;
    }

    .local-image-container {
      position: relative;
      margin: 20px 0 0;
      --phone-width: 200px;

      @media screen and (min-width: 360px) {
        --phone-width: 240px;
      }

      @media screen and (min-width: 380px) {
        --phone-width: 250px;
      }

      @media screen and (min-width: 400px) {
        --phone-width: 260px;
      }
    }
  }
`;

export const ReplikaChatVibePhoneStyles = styled.div`
  width: var(--phone-width);
  aspect-ratio: 0.574;
  display: block;

  img {
    width: 100%;
    height: 100%;
  }
`;

export const ReplikaChatVibeChatStyles = styled.div`
  position: absolute;
  left: 50%;
  top: 90px;
  transform: translate(-50%, 0);
  width: calc(var(--phone-width) * 1.13);
  aspect-ratio: 0.8;
  display: block;

  img {
    width: 100%;
    height: 100%;
  }

  @media screen and (min-width: 380px) {
    top: 103px;
  }
`;
